import { ColumnDef } from "@tanstack/react-table";
import { DataTableColumnHeader } from "./data-table-column-header";
import { DataTableRowActions } from "./data-table-row-actions";
import { Badge, BadgeProps } from "@/components/ui/badge";
import truncateText from "@/utils/truncateQuery";
import { QueryStatusEnum } from "@/enum/queryStatus";

const queryStatusConfig: Record<
  QueryStatusEnum,
  { text: string; variant: BadgeProps["variant"] }
> = {
  [QueryStatusEnum.APPROVED]: { text: "Aprovado", variant: "approved" },
  [QueryStatusEnum.PENDING]: { text: "Pendente", variant: "pending" },
  [QueryStatusEnum.REPROVED]: { text: "Reprovado", variant: "reproved" },
  [QueryStatusEnum.AUTO_APPROVED]: {
    text: "Aprovado Automaticamente",
    variant: "autoApproved",
  },
};

export const columns: ColumnDef<any>[] = [
  {
    accessorKey: "Responsável",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Responsável" />
    ),
    cell: ({ row }) => <div>{row.original.responsible.name}</div>,
  },
  {
    accessorKey: "Query",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Query" className="" />
    ),
    cell: ({ row }) => {
      const text = row.original.query;
      return truncateText(text, 20);
    },
  },
  {
    accessorKey: "Linhas Afetadas",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Linhas Afetadas" />
    ),
    cell: ({ row }) => <div>{row.original.affected_rows}</div>,
  },
  {
    accessorKey: "status",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Status" />
    ),
    cell: ({ row }) => {
      const status = row.getValue("status") as QueryStatusEnum;
      const config = queryStatusConfig[status] || {
        text: "Desconhecido",
        variant: "default",
      };

      return <Badge variant={config.variant}>{config.text}</Badge>;
    },
  },

  {
    accessorKey: "created_at",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Data de Criação" />
    ),
    cell: ({ row }) => {
      const date = row.getValue("created_at");
      if (date) {
        const parsedDate = new Date(date as string);
        if (!isNaN(parsedDate.getTime())) {
          const formattedDate = parsedDate
            .toLocaleString("pt-BR", {
              day: "2-digit",
              month: "2-digit",
              year: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            })
            .replace(", ", " - ");
          return formattedDate;
        } else {
          console.error("Data Inválida", date);
          return "Data Inválida";
        }
      } else {
        console.error("Date value is null or undefined");
        return "Sem data";
      }
    },
  },
  {
    id: "actions",
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
];
